import { useParams } from 'react-router';
import ReadAllArticles from './common/ReadAllArticles.react';
import ArticleBreadcrumbs from './common/ArticleBreadcrumbs.react';
import ArticleTitle from './common/ArticleTitle.react';
import ArticleSlideshow from './common/ArticleSlideshow.react';
import ArticleSubtitle from './common/ArticleSubtitle.react';
import ArticleParagraph from './common/ArticleParagraph.react';
import ArticleHero from './common/ArticleHero.react';
import ArticleBuyProduct from './common/ArticleBuyProduct.react';
import ArticleBottomBorder from './common/ArticleBottomBorder.react';
import ArticleProjectIcons from './common/ArticleProjectIcons.react';
import ArticleVideo from './common/ArticleVideo.react';
var DefaultArticle = function DefaultArticle(_ref) {
  var article = _ref.article;
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  var slug = article.slug;
  return /*#__PURE__*/React.createElement("section", {
    className: "a",
    id: "article-".concat(slug)
  }, /*#__PURE__*/React.createElement(ArticleHero, article), /*#__PURE__*/React.createElement(ArticleVideo, article), /*#__PURE__*/React.createElement("div", {
    className: "a__body ".concat(articleID ? 'a__body--wide' : '')
  }, /*#__PURE__*/React.createElement(ArticleBreadcrumbs, article), /*#__PURE__*/React.createElement(ArticleTitle, article), /*#__PURE__*/React.createElement(ArticleSlideshow, article), /*#__PURE__*/React.createElement(ArticleSubtitle, article), /*#__PURE__*/React.createElement(ArticleProjectIcons, article), /*#__PURE__*/React.createElement(ArticleParagraph, article), /*#__PURE__*/React.createElement(ArticleBuyProduct, article), /*#__PURE__*/React.createElement(ArticleBottomBorder, article), /*#__PURE__*/React.createElement(ReadAllArticles, {
    title: "Articles"
  })));
};
export default DefaultArticle;